import React from 'react';
import styled from '@emotion/styled';
import { Check, X } from 'lucide-react';

const StatusIconContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 600;
  
  ${props => props.status === 'found' && `
    background: #16a34a;
    color: white;
  `}
  
  ${props => props.status === 'not_found' && `
    background: #d1d5db;
    color: #6b7280;
  `}
`;

const StatusIcon = ({ status, size = 12 }) => {
  return (
    <StatusIconContainer status={status}>
      {status === 'found' ? <Check size={size} /> : <X size={size} />}
    </StatusIconContainer>
  );
};

export default StatusIcon;
